import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';

import './artwork.scss';

@inject('appStore', 'routerStore')
@observer
export class ArtworkComponent extends Component {

    render() {
        const { artwork } = this.props;

        return <div
            style={this.props.style}
            tabIndex={this.props.tabIndex}
            className={this.props.className}
        >
            <div className='artwork'>
                <div className='artwork-container'>
                    <div className={`artwork-inner artwork-inner--${artwork.Orientation}`}>
                        <img className='artwork-image'src={artwork.ImageURL} />
                        <div className='artwork-content'>
                            <h3 className='artwork-title'>{artwork.Title}</h3>
                            {artwork.Artist && <p className='artwork-artist'>{artwork.Artist}</p>}
                            <p className='artwork-meta'>
                                {artwork.Date && <span>{artwork.Date}</span>}
                                {artwork.Medium && <span>{artwork.Medium}</span>}
                                {artwork.Size && <span>{artwork.Size}</span>}
                            </p>
                            <div className='artwork-text' dangerouslySetInnerHTML={{ __html: artwork.Content }} />
                        </div>
                        <div className='artwork-fade' />
                    </div>
                </div>
            </div>
        </div>;
    }

}



// WEBPACK FOOTER //
// ./src/_artwork/artwork.component.js